export default __webpack_public_path__ + "static/media/bg1_mob_.39da5680.png";